import { AuthToken } from "./authentication/types";
import { ApiCallModel } from "../models/ApiCallModel";
import { authenticationReducer } from "./authentication/reducers";
import { AuthenticationState } from "react-aad-msal";
import * as ActivityLogs from "./ActivityLogsStore";
import * as General from "./GeneralStore";
import * as LineHandlingStore from "./LineHandlingStore";
import * as TruckNominationStore from "./TruckNominationStore";
import * as OfflineData from "./OfflineDataStore";
import * as ProcessFlowConfig from "./ProcessFlowConfigStore";
import * as SelectedTab from "./SelectedTabDataStore";
import * as SofViewStore from "./SofViewStore";
import * as WorkPacketStore from "./WorkPacketStore";

import * as TruckWorkPacketStore from "./TruckWorkPacketStore";

export interface State {
  authentication: AuthToken | undefined;
  offlineData: OfflineData.OfflineDataState | undefined;
  selectedTab: SelectedTab.SelectedTabState | undefined;
  general: General.GeneralState;

  lineHandling: LineHandlingStore.LineHandlingState;
  sofView: SofViewStore.SofViewState;
  activityLogs: ActivityLogs.ActivityLogsState;
  processFlowConfigState: ProcessFlowConfig.ProcessFlowConfigState;
  workPacket: WorkPacketStore.WorkPacketState;
  truckNomination: TruckNominationStore.TruckNominationState;
  truckWorkPacket: TruckWorkPacketStore.TruckWorkPacketState;
}

const defaultApiModel: ApiCallModel<any> = {
  isError: false,
  isLoading: false,
  result: undefined,
};

export const InitialState: State = {
  authentication: {
    initializing: false,
    initialized: false,
    idToken: "",
    accessToken: "",
    state: AuthenticationState.Unauthenticated,
    account: null,
  },
  general: General.defaultState,
  lineHandling: LineHandlingStore.defaultState,
  sofView: SofViewStore.defaultState,
  offlineData: OfflineData.defaultState,
  selectedTab: SelectedTab.defaultState,
  activityLogs: ActivityLogs.defaultState,
  processFlowConfigState: ProcessFlowConfig.defaultState,
  workPacket: WorkPacketStore.defaultState,
  truckNomination: TruckNominationStore.defaultState,
  truckWorkPacket: TruckWorkPacketStore.defaultState,
};

export const reducers = {
  authentication: authenticationReducer,
  general: General.reducers,
  sofView: SofViewStore.reducers,
  offlineData: OfflineData.reducer,
  selectedTab: SelectedTab.reducers,

  activityLogs: ActivityLogs.reducers,
  lineHandling: LineHandlingStore.reducers,
  processFlowConfigState: ProcessFlowConfig.reducers,
  workPacket: WorkPacketStore.reducers,
  truckNomination: TruckNominationStore.reducers,
  truckWorkPacket: TruckWorkPacketStore.reducers,
};

export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => State): void;
}
